import axios from '../axiosConfig'; // Adjust the import path accordingly
import Email from './Email';

//const express_server_url = process.env.REACT_APP_SERVER_URL;
const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;


var WebApiUrl = express_server_url;
WebApiUrl = express_server_url.replace("localhost", window.location.hostname);


const OTPService = {

    SendOTP: async(Email="", Phone="") =>{

        const apiUrl = `${WebApiUrl}/api/SendOtp/`;

        const data = {
            "mobileNo": Phone,
            "emailId": Email
        }

        return await axios.post(
            apiUrl,
            data,
            {
                withCredentials: true,
                credentials: "include",
            }
        );

    },

    CompanySendOTP: async (EmailId) => {

        const apiUrl = `${WebApiUrl}/api/SendOtp/CompanySendOTP?EmailId=${EmailId}`;

        return await axios({
            method: 'post',
            url: apiUrl,
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },

    CreateOTPInfo: async (Email = "", Phone = "") => {

        const apiUrl = `${WebApiUrl}/api/SendOtp/CreateOTPInfo`

        const data = {
            "mobileNo": Phone,
            "email": Email
        }

        return await axios.post(
            apiUrl,
            data,
            {
                withCredentials: true,
                credentials: "include",
            }
        );
    },

    VerifyOtp: async (OTP = "", Email = "", Phone = "") => {

        const apiUrl = `${WebApiUrl}/api/SendOtp/VerifyOtp`;

        const data = {
            "otp": OTP,
            "mobileNo": Phone,
            "email": Email
        }

        return await axios.post(
            apiUrl,
            data,
            {
                withCredentials: true,
                credentials: "include",
            }
        );
    },


};

export default OTPService;